module.exports = __webpack_public_path__ + "81b59bfe0cdc83152b99e3c87a8ba6f4.MP3";